import React from "react";
import "./resources/scss/base/common.scss";
import { Provider } from "react-redux";
import { Routes } from "react-router";
import AutofactThemeProvider from '@autofact/ant-design/build/theme';

import { BrowserRouter, Route } from "react-router-dom";

import TrfSimulatorRoute from "./components/routes/TrfSimulator/TrfSimulatorRoute";
import storage from "./store/Storage";
import UserOptionsRoute from "components/routes/ContractRoutes/UserOptionsRoute";
import TransferenceTypes from "components/routes/ContractRoutes/TransferenceTypes";
import ContractFromRoute from "components/routes/ContractRoutes/ContractFromRoute";
import ContractTAGServiceRoute from "components/routes/ContractRoutes/ContractTAGServiceRoute";
import DocumentPaySignRoute from "components/routes/ContractRoutes/DocumentPaySignRoute";
import CongratulationsRoute from "components/routes/ContractRoutes/CongratulationsRoute";
import InitTransference from "components/routes/ContractRoutes/TransferenceNowRoute";
import { ConfigProvider } from "antd";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import growthbook from 'helpers/growthbook/growthbook';
import ZendeskWidgetController from "components/reusables/ZendeskController/ZendeskController"

function App() {
  return (
    <GrowthBookProvider growthbook={growthbook.gb}>
      <AutofactThemeProvider>
        <ConfigProvider layout={{ style: { background: 'white' } }}>
          <Provider store={storage}>
            <ZendeskWidgetController />
            <div id={'App'}>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<TrfSimulatorRoute />} />
                  <Route path="/opciones" element={<UserOptionsRoute />} />
                  <Route path="/opciones/modalidad-transferencia/" element={<TransferenceTypes />} />
                  <Route path="/opciones/contrato-formulario/" element={<ContractFromRoute />} />
                  <Route path="/opciones/contrato-servicio-tag/" element={<ContractTAGServiceRoute />} />
                  <Route path="/opciones/contrato-firma-pago/" element={<DocumentPaySignRoute />} />
                  <Route path="/opciones/transferencia-lista/" element={<CongratulationsRoute />} />
                  <Route path="/opciones/iniciar-transferencia/" element={<InitTransference />} />
                </Routes>
              </BrowserRouter>
            </div>
          </Provider>
        </ConfigProvider>
      </AutofactThemeProvider>
    </GrowthBookProvider>

  );
}

export default App;
